import hoverTick from "../../../public/sounds/HoverTick.mp3";

const videoHover = () => {
    const player = new Audio(hoverTick);
    player.play();
}

export default videoHover;